import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Combo,TableItem } from 'src/pages/venues/types';

interface FloorBuilderState {
	openSidebar: boolean;
	tables: TableItem[];
	initialTables: TableItem[];
	combos: Combo[];
	initialCombos: Combo[];
	comboToCreate: TableItem[] | null;
	comboToEdit: Combo | null;
}

const initialState: FloorBuilderState = {
	openSidebar: false,
	tables: [],
	initialTables: [],
	combos: [],
	initialCombos: [],
	comboToCreate: null,
	comboToEdit: null,
};

const floorBuilderSlice = createSlice({
	name: 'floorBuilder',
	initialState,
	reducers: {
		setSidebarOpen: (state) => {
			state.openSidebar = !state.openSidebar;
		},
		setTables: (state, action: PayloadAction<TableItem[]>) => {
			state.tables = action.payload;
		},
		setInitialTables: (state, action: PayloadAction<TableItem[]>) => {
			state.initialTables = action.payload;
		},
		resetTables: (state) => {
			state.tables = state.initialTables;
		},
		setCombos: (state, action: PayloadAction<Combo[]>) => {
			state.combos = action.payload;
		},
		setInitialCombos: (state, action: PayloadAction<Combo[]>) => {
			state.initialCombos = action.payload;
		},
		resetCombos: (state) => {
			state.combos = state.initialCombos;
		},
		setComboToCreate: (state, action: PayloadAction<TableItem[] | null>) => {
			state.comboToCreate = action.payload;
		},
		setComboToEdit: (state, action: PayloadAction<Combo | null>) => {
			state.comboToEdit = action.payload;
		},
	},
});

export const {
	setSidebarOpen,
	setInitialTables,
	setTables,
	setCombos,
	setInitialCombos,
	resetTables,
	setComboToCreate,
	setComboToEdit,
	resetCombos,
} = floorBuilderSlice.actions;

export const selectTables = (state: { venue: { floorBuilder: FloorBuilderState } }) => state.venue.floorBuilder.tables;
export const selectInitialTables = (state: { venue: { floorBuilder: FloorBuilderState } }) => state.venue.floorBuilder.initialTables;
export const selectCombos = (state: { venue: { floorBuilder: FloorBuilderState } }) => state.venue.floorBuilder.combos;
export const selectInitialCombos = (state: { venue: { floorBuilder: FloorBuilderState } }) => state.venue.floorBuilder.initialCombos;
export const selectOpenSidebar = (state: { venue: { floorBuilder: FloorBuilderState } }) => state.venue.floorBuilder.openSidebar;
export const selectComboToCreate = (state: { venue: { floorBuilder: FloorBuilderState } }) => state.venue.floorBuilder.comboToCreate;
export const selectComboToEdit = (state: { venue: { floorBuilder: FloorBuilderState } }) => state.venue.floorBuilder.comboToEdit;

export default floorBuilderSlice.reducer;
